import { render, staticRenderFns } from "./storeDemandInfo.vue?vue&type=template&id=344253a4&scoped=true&"
import script from "./storeDemandInfo.vue?vue&type=script&lang=js&"
export * from "./storeDemandInfo.vue?vue&type=script&lang=js&"
import style0 from "./storeDemandInfo.vue?vue&type=style&index=0&id=344253a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344253a4",
  null
  
)

export default component.exports